import type { Datapoints, Timeseries } from '@cognite/sdk';

export const filterDatapointStrings = (datapoints: Datapoints[]) =>
  datapoints.filter(({ isString }) => isString === false);

export const filterTimeseriesStrings = (timeseries: Timeseries[]) =>
  timeseries.filter(({ isString }) => isString === false);
